import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';

import { isNilOrEmpty } from 'helpers';

/**
 * Format of data for the dialog
 */
export interface AddAssessmentDialogData {
  campaignId: string;
  entityId: string;
  entityTypeId: string;
}

@Component({
  selector: 'app-add-assessment-dialog',
  templateUrl: './add-assessment.dialog.html'
})
export class AddAssessmentDialog implements OnInit {
  assessmentSaved = false;

  static open(dialog: MatDialog, config: MatDialogConfig<AddAssessmentDialogData>) {
    return dialog.open(AddAssessmentDialog, config);
  }

  constructor(
    public dialogRef: MatDialogRef<AddAssessmentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddAssessmentDialogData
  ) { }

  ngOnInit(): void {
    if (isNilOrEmpty(this.data?.entityId) || isNilOrEmpty(this.data?.campaignId)) {
      throw new Error('An entityId and campaignId must be passed as data to `AddOrUpdateAddressDialog`');
    }
  }

  onAssessmentSaved(event: any) {
    this.assessmentSaved = true;
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }
}
